@if (showTermsAndConditionsAcceptanceLog) {
<div>
  <div class="card card-custom card-stretch gutter-b mb-5">
    <div class="card-header pt-3">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-semibold"
          translate="TRANSLATE.DASHBOAR_HEADER_TEXT_TERMS_AND_CONDITIONS_ACCEPTED"></span>
      </h3>
    </div>
    <div class="card-body pt-2 pb-0 mt-n3">
      <div class="table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl">
        <table class="table table-borderless mb-6">
          <tbody>
            @for(TermsAndCondition of userTermsAndConditionLogs; track $index){


            <tr>
              <td>
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-45 symbol-light-info me-2">
                    <span class="symbol-label">
                      <i class="ki-outline ki-profile-circle fs-2x text-primary"></i>
                           
                    </span>
                  </div>
                  <div class="ml-2">
                    <div class="text-dark-75 font-weight-bolder font-size-lg mb-0">
                      <span>{{ TermsAndCondition.EmailAddress }}</span>
                    </div>
                    <div class="font-weight-bold text-muted">
                      <strong>
                        @if (TermsAndCondition.AgreementType == 'PartnerAgreement') { <span translate="TRANSLATE.DASHBOAR_TEXT_PARTNER_TERMS_AND_CONDITIONS_URL"></span>}
                        @if (TermsAndCondition.AgreementType == 'EzidebitAgreement') {<span  translate="TRANSLATE.DASHBOAR_TEXT_EZIDEBIT_AGREEMENT_URL"></span>}
                          @if (TermsAndCondition.AgreementType == 'MicrosoftCloudAgreement') {<span  translate="TRANSLATE.DASHBOAR_TEXT_MICROSOFT_CLOUD_AGREEMENT_URL"></span>}
                      </strong>
                      @if (TermsAndCondition.AgreementType == 'PartnerAgreement' || TermsAndCondition.AgreementType == 'EzidebitAgreement' || TermsAndCondition.AgreementType == 'MicrosoftCloudAgreement') {<br>}
                      <a href="{{ TermsAndCondition.AgreementURL }}" target="_blank">{{ TermsAndCondition.AgreementURL  }}</a>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <span class="font-weight-bold d-block" translate="TRANSLATE.DASHBOAR_TEXT_DATE"></span>
                <a class="fw-semibold text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">{{formatDate(TermsAndCondition.CreateDate) }}</a>
              </td>
              <td>
                <span class="font-weight-bold d-block" translate="TRANSLATE.DASHBOAR_TEXT_TIME"></span>
                <a class="fw-semibold text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">{{ TermsAndCondition.Time
                  }}</a>
              </td>
              <td>
                <span class="font-weight-bold d-block" translate="TRANSLATE.DASHBOAR_TEXT_IP"></span>
                <a class="fw-semibold text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">{{
                  TermsAndCondition.UserIPAddress }}</a>
              </td>
            </tr>


            }

            @if (userTermsAndConditionLogs.length === 0 && !isGridDataLoading) {
            <tr>
              <td colspan="5" translate="TRANSLATE.MESSAGE_NO_RECORDS_FOUND"></td>
            </tr>
            }
            @if (isGridDataLoading) {
            <tr>
              <td colspan="5"><img src="../img/loading.gif" alt="{{ 'TRANSLATE.Loading' | translate }}" /></td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
}